<template>
  <v-card>
    <v-toolbar color="secondary" class="elevation-0">
      <v-toolbar-title> Ledger Export </v-toolbar-title>
    </v-toolbar>
    <v-card-actions class="mt-5">
      <v-row>
        <v-col>
          <div>
            <v-menu :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  dense
                  outlined
                  :value="startDate"
                  prepend-inner-icon="mdi-calendar-clock"
                  append-inner-icon="mdi-menu-down"
                  class="mx-5"
                  style="height: 40px; min-width: 180px"
                  label="From"
                  :max="endDate"
                />
              </template>
              <v-list class="pa-0" style="max-width: fit-content">
                <v-list-item class="pa-0">
                  <v-list-item-title>
                    <v-date-picker
                      v-model="startDate"
                      show-adjacent-months
                      :max="endDate"
                    />
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>

        <v-col>
          <div>
            <v-menu :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  dense
                  outlined
                  :value="endDate"
                  prepend-inner-icon="mdi-calendar-clock"
                  append-inner-icon="mdi-menu-down"
                  class="mx-5"
                  style="height: 40px; min-width: 180px"
                  label="To"
                />
              </template>
              <v-list class="pa-0" style="max-width: fit-content">
                <v-list-item class="pa-0">
                  <v-list-item-title>
                    <v-date-picker
                      v-model="endDate"
                      show-adjacent-months
                      :min="startDate"
                    />
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="eventGroup"
            :items="[
              { text: 'Amount', value: 'amount' },
              { text: 'Count', value: 'count' },
              { text: 'Quantity', value: 'quantity' },
            ]"
            dense
            outlined
            label="Event Group"
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="frequency"
            :items="[
              { text: 'Monthly', value: 'ME' },
              { text: 'Daily', value: 'D' },
            ]"
            dense
            outlined
            label="Frequency"
          />
        </v-col>

        <v-col>
          <v-btn
            color="grey darken-1"
            :disabled="!eventGroup || !frequency"
            :loading="loading"
            @click="requestCSV"
          >
            <v-icon class="mr-3">mdi-download</v-icon>
            Export as CSV
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import client from "@/lib/ApiClient";
import { formatDate, endOfDay } from "@/lib/utils";

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const defaultStart = new Date(new Date().getTime() - 365 * DAY_IN_MS);
const defaultEnd = new Date();

export default {
  data: () => ({
    loading: false,
    startDate: formatDate(defaultStart),
    endDate: formatDate(defaultEnd),
    eventGroup: null,
    frequency: null,
  }),

  methods: {
    async requestCSV() {
      this.loading = true;
      const blob = await client.gateway.management.fetchLedgerAggregateCSV(
        this.eventGroup,
        this.frequency,
        new Date(this.startDate).toISOString(),
        endOfDay(this.endDate).toISOString()
      );

      this.loading = false;

      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `NCLab Export ${this.eventGroup} ${this.frequency} ${this.startDate} ${this.endDate}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};
</script>
